import { useSelector } from 'react-redux';
import { selectBreadcrumbs } from '../../selectors/breadcrumbs';
import { Breadcrumbs, Breadcrumb } from '../../components/Breadcrumbs';
import * as React from 'react';

export const BreadcrumbsContainer: React.FC = () => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  if (!breadcrumbs.length) {
    return null;
  }

  return (
    <Breadcrumbs>
      {breadcrumbs.map((breadcrumb, key) => (
        <Breadcrumb key={key} {...breadcrumb} />
      ))}
    </Breadcrumbs>
  );
};
